import styled from 'styled-components';
import { useTheme } from '../../context/ThemeContext';
import { ReactComponent as Moon } from '../../assets/moon.svg';
import { ReactComponent as Sun } from '../../assets/sun.svg';
import { motion } from 'framer-motion';

const DarkModeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  return (
    <ToggleButton
      as={motion.button}
      onClick={toggleTheme}
      whileHover={{ scale: 1.2 }}
    >
      {isDarkMode ? <IconMoon /> : <IconSun />}
    </ToggleButton>
  );
};

const ToggleButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.2);
  }
`;

const IconMoon = styled(Moon)`
  margin-top: 8px;
  margin-bottom: 7px;
  margin-right: 6px;
  height: 25px;
  color: ${({ theme }) => theme.text};
  @media (max-width: 500px) {
    height: 20px;
    margin-top: 10px;
    margin-bottom: 0px;
    margin-right: 7px;
  }
`;

const IconSun = styled(Sun)`
  height: 40px;
  color: ${({ theme }) => theme.text};
  @media (max-width: 500px) {
    height: 30px;
    margin-top: 5px;
    margin-bottom: -5px;
  }
`;

export default DarkModeToggle;
